import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { AutocompleteItemWrapper } from "@similarweb/ui-components";

export const LEFT_DISTANCE = 53;
const HORIZONTAL_LINE_WIDTH = 23;

const getVerticalLineHeight = ({ isFirst, isLast }: { isFirst: boolean; isLast: boolean }) => {
    if (isFirst && !isLast) {
        return "100%";
    }
    return isFirst || isLast ? "50%" : "100%";
};

export const StyledAutocompleteDivider = styled.div`
    width: 1px;
    height: 10px;
    background-color: ${colorsPalettes.carbon[100]};
    margin-right: 8px;
`;

export const StyledAutocompleteDomainWrapper = styled(AutocompleteItemWrapper)<{
    isFirst: boolean;
    isLast: boolean;
    isDisabled?: boolean;
}>`
    position: relative;
    padding-left: ${LEFT_DISTANCE + HORIZONTAL_LINE_WIDTH}px;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

    &::before {
        content: "";
        display: block;
        position: absolute;
        bottom: ${({ isLast }) => (isLast ? "50%" : 0)};
        left: ${LEFT_DISTANCE}px;
        width: 1px;
        height: ${getVerticalLineHeight};
        background-color: ${colorsPalettes.carbon[100]};
    }

    &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: 50%;
        left: ${LEFT_DISTANCE}px;
        width: ${HORIZONTAL_LINE_WIDTH}px;
        height: 1px;
        background-color: ${colorsPalettes.carbon[100]};
    }
`;
